import React from "react";

function TextAreaField({
  fieldName,
  required = false,
  handleOnChange,
  value = "",
  rows = 4,
}) {
  return (
    <div className="fields">
      <span className="field-name">
        {fieldName} {required && <span className="epr-required">*</span>}
      </span>

      <textarea
        className={fieldName}
        rows={rows}
        value={value}
        onChange={(e) => handleOnChange(fieldName, e.target)}
      />
    </div>
  );
}

export default TextAreaField;